import Routing from "routing";
import { Toaster } from "react-hot-toast";
import { Provider } from "react-redux";
import { store, persistor } from "./redux/store";
import { PersistGate } from "redux-persist/integration/react";
import React, { useEffect } from "react";
import { QueryClient, QueryClientProvider } from "react-query";
import { ReactQueryDevtools } from "react-query/devtools";
import { BrowserRouter } from "react-router-dom";
import { Helmet } from 'react-helmet';
import "./App.css";
import ErrorBoundary from "components/ErrorBondries";
import {socket} from "./socket.js"
import { initGA } from "utils/analytics";


export const App = () => {
  const queryClient = new QueryClient();

  useEffect(() => {
    initGA();
  }, []);
  
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <QueryClientProvider client={queryClient}>
          <ReactQueryDevtools initialIsOpen={false} />
          <BrowserRouter>
            <Routing socket = {socket} />
          </BrowserRouter>
          <Toaster />
        </QueryClientProvider>
      </PersistGate>
    </Provider>
  );
};

export default App;
